import React from "react";
import { useTranslation } from "react-i18next";

import { buildTenantHost, parseCotenHostname } from "~/features/tenant/utils";

export function useTenantSwitcher(onBeforeNavigate?: () => void) {
  const { t } = useTranslation();

  const switchToTenant = React.useCallback(
    (tenantShortCode: string) => {
      onBeforeNavigate?.();

      const parsed = parseCotenHostname(window.location.hostname);
      if (!parsed.app || !parsed.tld) {
        console.warn(t("feature.tenant.parseHostnameSkipNavigation"), {
          hostname: window.location.hostname,
          tenantShortCode,
        });
        throw new Error(t("feature.tenant.switchFromUrlError"));
      }

      const desiredHost = buildTenantHost({
        tenantShortCode,
        app: parsed.app,
        tld: parsed.tld,
      });

      const url = new URL(window.location.href);
      if (url.hostname === desiredHost) {
        return;
      }

      url.hostname = desiredHost;
      window.location.replace(url.toString());
    },
    [onBeforeNavigate, t],
  );

  return { switchToTenant };
}
